var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#DB2F2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.801 10.224C6.489 8.131 8.699 7.286 8.699 6.051C8.699 5.401 8.27 4.985 7.594 4.985C7.022 4.985 6.567 5.284 6.151 5.713L5.098 4.751C5.774 3.984 6.697 3.451 7.828 3.451C9.388 3.451 10.532 4.257 10.532 5.921C10.532 7.767 8.27 8.391 8.465 10.224H6.801ZM7.633 13.682C6.957 13.682 6.45 13.136 6.45 12.434C6.45 11.719 6.957 11.186 7.633 11.186C8.322 11.186 8.829 11.719 8.829 12.434C8.829 13.136 8.322 13.682 7.633 13.682Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpo);
export default __webpack_public_path__ + "static/media/npo.da16f888cf6f9e149a60582f22debf1b.svg";
export { ForwardRef as ReactComponent };